




















































































































import Vue from 'vue';
import {UserApi} from '@/api/user-api';
import {UserClass} from '@/types/userClass';
import {InitiatorClass} from '@/types/InitiatorClass';
import UserForm from '@/components/UserForm.vue';
import {UserRole} from '@/types/user-role';

export default Vue.extend({
  name: 'UserList',
  components: {UserForm},
  beforeMount() {
    this.getData();
  },
  data() {
    return {
      users: [] as UserClass[],
      editUser: false,
      snackbar: false,
      snackbarText: '',
      userRole: UserRole
    };
  },
  methods: {
    getData() {
      UserApi.getList().then(res => this.users = res.data);
    },
    setActiveUser(index: number) {
      const user = this.users[index];
      user.active = !user.active;
      UserApi.edit(user.id, user);
    },
    add(user: UserClass) {
      UserApi.save(user).then(() => {
          this.users.push(user);
          this.editUser = false;
          this.snackbarText = 'Пользователь добавлен';
          this.snackbar = true;
        },
        () => {
          this.snackbarText = 'Произошла ошибка при сохранении';
          this.snackbar = true;
          this.editUser = false;
        });
    },
    save(user: UserClass) {
      return UserApi.save(user);
    },
    edit(ind: number) {
      UserApi.edit(this.users[ind].id, this.users[ind]);
    }
  }
});
